import React from 'react';
import { XCircle } from 'lucide-react';
const problems = ['Fines de semana buscando información en internet que nunca aplica exactamente a tu situación', 'Albañiles que te dan tres precios distintos y no sabés a cuál creerle', 'Empezaste la obra y en el camino aparecieron gastos que nadie te avisó', 'El Cómputo de materiales, el hormigón armado, la instalación eléctrica — sin guía práctica en tu idioma', 'Distintas etapas sin saber en qué orden construir para no desperdiciar plata', 'Fin de semana agotado, el lunes volvés a empezar el mismo ciclo de dudas'];
export function ProblemSection() {
  return <section className="py-20 bg-charcoal text-white pt-[27px] pb-[27px]" data-id="element-281">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-282">
        <div className="space-y-6 text-lg text-gray-300 mb-12" data-id="element-283">
          <p data-id="element-284">
            Querés construir tu casa. Tenés el terreno o estás por tenerlo.
            Tenés las ganas — llevan tiempo ahí.
          </p>
          <p data-id="element-285">
            Pero nadie te dijo que ibas a pasar los fines de semana buscando
            información que no encaja, hablando con albañiles que te dan precios
            diferentes y llegando al lunes sin saber si lo que te dijeron tiene
            sentido.
          </p>
          <p className="font-semibold text-gold" data-id="element-286">
            No es falta de ganas. Es falta de un sistema.
          </p>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-xl p-6 md:p-8 space-y-4" data-id="element-287">
          {problems.map((problem, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-288">
              <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-289" />
              <p className="text-gray-200" data-id="element-290">{problem}</p>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-291">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold italic" data-id="element-292">
            ¿Y si este fuera el último fin de semana que pasás así?
          </h3>
        </div>
      </div>
    </section>;
}